module.exports = {
  header: "お問い合わせ",
  personal: "個人のお客様",
  message_success: "お問い合わせが完了しました。通常3営業日以内にご返信差し上げます。",
  message_fail: "エラーが発生しました。再度お試しください。",
  business: "法人・行政のお客様",
  text1: "お問い合わせいただきありがとうございます。",
  text2: "xIDの使用方法などに関するご質問は",
  text2_hightlight: "FAQ",
  text2_end_dot: "もご確認ください。",
  name:"お名前",
  firstname: "名*",
  lastname: "姓*",
  mail: "Eメールアドレス*",
  company: "会社名*",
  title: "お問い合わせ内容",
  inquiry1: "xID APIの導入を検討している",
  inquiry2: "パートナーシップ / 業務提携に関して",
  inquiry3: "xIDの利用・不具合について",
  inquiry4: "取材 / メディア掲載 / イベント登壇について",
  inquiry5: "弊社向けの営業",
  inquiry6: "その他のお問い合わせについて",
  message: 'お問い合わせ内容詳細',
  division_name: '事業部名*',
  job: "役職名*",
  phone_number: "電話番号",
  listing: "上場区分",
  listing_division1: "上場企業",
  listing_division2: "非上場企業",
  listing_division3: "行政機関",
  send: "送信",
  required_error: "必須項目です",
  format_error: "正しいフォーマットで入力してください",
};